.DiceboundModal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(34, 34, 34, 0.5);
}
.DiceboundModal .Header,
.DiceboundModal .Footer {
  font-size: 0.5em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  margin-top: 2em;
  margin-bottom: 2em;
}
.DiceboundModal .Header .BigText,
.DiceboundModal .Footer .BigText {
  font-size: 1.3em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText,
.DiceboundModal .Footer .SmallText {
  font-size: 0.75em;
  line-height: 1em;
}
.DiceboundModal .Header .SmallText[isHoverable]:hover,
.DiceboundModal .Footer .SmallText[isHoverable]:hover {
  color: hotpink;
}
.DiceboundModal .UnitsSection {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiceboundModal .UnitsSection .Or {
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit {
  font-size: 0.75em;
  margin: 0em 0.2em;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition-duration: 0.25s;
  transition-property: opacity, filter, transform;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail {
  width: 1em;
  height: 1em;
  position: relative;
  margin-top: 0.4em;
}
.DiceboundModal .UnitsSection .Unit .Thumbnail .UnitHealthBar {
  left: 0em;
  right: 0em;
  margin: auto;
  bottom: 0em;
  height: 0.15em;
  max-width: 0.66em;
  position: absolute;
}
.DiceboundModal .UnitsSection .Unit .DraftButton {
  margin-top: 1.4em;
  width: 8em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--editor-font);
}
.DiceboundModal .UnitsSection .Unit .DraftButton span {
  font-size: 1rem;
  line-height: 1rem;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Number {
  font-size: 0.25em;
  text-align: center;
  margin-bottom: 0.25em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name {
  font-size: 0.5em;
  text-align: center;
  margin-bottom: 0.5em;
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
  height: 1em;
  line-height: 1em;
  position: relative;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .Description span,
.DiceboundModal .UnitsSection .Unit .DraftableDice .Name span {
  left: -3em;
  right: -3em;
  position: absolute;
  text-align: center;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout {
  background-color: transparent;
  border: none;
  font-size: 1em;
}
.DiceboundModal .UnitsSection .Unit .DraftableDice .DiceLayout .Dice .DiceFace {
  border-style: solid;
  border-width: 0.1em;
  border-radius: 0.1em;
  border-color: #111111;
}
.DiceboundModal .UnitsSection .Unit .EquippedDice {
  font-size: 0.5em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice {
  margin-top: 0.2em;
}
.DiceboundModal .UnitsSection .Unit .EquippableDice .Description {
  font-size: 0.25em;
  text-align: center;
  font-family: var(--header-font);
  text-stroke: 0.35em #111111;
  -ms-text-stroke: 0.35em #111111;
  -moz-text-stroke: 0.35em #111111;
  -webkit-text-stroke: 0.35em #111111;
  paint-order: stroke fill;
}
.DiceboundModal .UnitsSection .Unit .Status {
  left: 0em;
  right: 0em;
  bottom: -1.4em;
  position: absolute;
  line-height: 1em;
  text-align: center;
  font-size: 0.3em;
  text-stroke: 0.2em #111111;
  -ms-text-stroke: 0.2em #111111;
  -moz-text-stroke: 0.2em #111111;
  -webkit-text-stroke: 0.2em #111111;
  paint-order: stroke fill;
  opacity: 0;
  transition-duration: 0.5s;
  transition-property: opacity;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] {
  filter: grayscale(2);
  opacity: 0.75;
  transform: translateY(-0.5em);
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Label {
  display: none;
}
.DiceboundModal .UnitsSection .Unit[isLockedIn] .Status {
  opacity: 1;
}
.DiceboundModal .DoneSection {
  padding-top: 0.5em;
  text-align: center;
}
.DiceboundModal .DoneSection button {
  font: inherit;
  font-size: 0.5em;
  padding: 0em 1em;
}
.DiceboundModal .DoneSection button:not([isEnabled]) {
  opacity: 0.5;
}
.DiceboundModal .DoneSection button:not(:last-child) {
  margin-right: 0.5em;
}
.DiceboundModal .LootablePassiveSection {
  width: 6em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.DiceboundModal .LootablePassiveSection .LootablePassive {
  width: 100%;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit {
  top: 0em;
  width: 1em;
  right: 0.2em;
  bottom: 0em;
  position: absolute;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Unit .UnitSprite {
  top: 0em;
  bottom: 0em;
  margin: auto;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary {
  font-size: 0.5em;
  padding: 0.618em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Title {
  font-size: 1em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive .Summary .Description {
  font-size: 0.5em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:not(:last-child) {
  margin-bottom: 0.2em;
}
.DiceboundModal .LootablePassiveSection .LootablePassive:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}
.MerchantModal {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  background-color: rgba(74, 92, 108, 0.8);
}
.MerchantModal .ButtonsSection {
  right: 0.2em;
  bottom: 2.2em;
  position: absolute;
}
.MerchantModal .ButtonsSection .DoneButton {
  font-size: 0.4em;
  padding: 0.1em 0.6em;
  border-radius: 0.2em;
  background-color: #4A5C6C;
  transition-duration: 0.2s;
  transition-property: opacity;
}
.MerchantModal .ButtonsSection .DoneButton:not([isVisible]) {
  opacity: 0;
}
.MerchantModal .ButtonsSection .DoneButton[isVisible] {
  opacity: 0.8;
}
.MerchantModal .ButtonsSection .DoneButton[isVisible]:hover {
  cursor: pointer;
  background-color: #8ABEC0;
}
.MerchantModal .StatusSection {
  top: 0em;
  left: 0em;
  padding: 0.2em;
  position: absolute;
}
.MerchantModal .StatusSection .GoldCount {
  min-width: 4.75em;
  font-size: 0.3em;
  text-align: center;
  padding: 0.1em 0.6em;
  border-radius: 0.2em;
  background-color: #4A5C6C;
}
.MerchantModal .ItemsSection {
  height: 2em;
  background-color: rgba(74, 92, 108, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1em;
}
.MerchantModal .ItemsSection .DraftableItem {
  width: 1em;
  height: 1em;
}
.MerchantModal .ItemsSection .DraftableItem[isDraftable] {
  cursor: pointer;
}
.MerchantModal .ItemsSection .DraftableItem:not([isDraftable]) {
  opacity: 0.5;
}
.MerchantModal .ItemsSection .DraftableItem .Cost {
  font-size: 0.2em;
  text-align: center;
}
.MerchantModal .ItemsSection .EmptyItem {
  width: 1em;
  height: 1em;
  opacity: 0.5;
}
.MerchantModal .ItemsSection .RerollButton {
  width: 1em;
  height: 1em;
  position: relative;
  cursor: pointer;
}
.MerchantModal .ItemsSection .RerollButton .IconBox {
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
.MerchantModal .ItemsSection .RerollButton .IconBox .Icon {
  width: 80%;
  height: 80%;
}
.MerchantModal .ItemsSection .RerollButton .Cost {
  font-size: 0.2em;
  text-align: center;
}
.MerchantModal .ItemsSection .RerollButton:not([isClickable]) {
  opacity: 0.5;
}
.MerchantModal .ItemsSection .RerollButton .Label {
  left: -1.5em;
  right: -1.5em;
  z-index: 110;
  text-align: center;
  position: absolute;
  opacity: 0;
  transform: translateY(0.1em);
  transition-duration: 0.1s;
  transition-property: transform, opacity;
  pointer-events: none;
}
.MerchantModal .ItemsSection .RerollButton .Label .Title {
  font-size: 1rem;
  line-height: 1rem;
  font-family: var(--base-font);
}
.MerchantModal .ItemsSection .RerollButton .Label .Title span {
  padding: 0em 0.2em;
  background-color: #111111;
}
.MerchantModal .ItemsSection .RerollButton[anchored=bottom] .Label {
  top: 1.25em;
}
.MerchantModal .ItemsSection .RerollButton[anchored=top] .Label {
  bottom: 1.25em;
}
.MerchantModal .ItemsSection .RerollButton:hover .Label {
  opacity: 1;
  transform: translateY(0em);
}
.MerchantModal .SelectedItemCursor {
  width: 1em;
  height: 1em;
  z-index: 100;
  position: fixed;
  margin-top: -0.5em;
  margin-left: -0.5em;
  pointer-events: none;
  display: none;
}
.MerchantModal[hasSelectedItem] .SelectedItemCursor {
  display: block;
}
.MerchantModal[hasSelectedItem] .Dice .Label {
  display: none !important;
}
.MerchantModal[hasSelectedItem] .Dice .ItemBreakdown {
  display: none !important;
}
.MerchantModal .Tutorial {
  opacity: 0;
  pointer-events: none;
  position: absolute;
  width: 100%;
  height: 100%;
}
.MerchantModal .Tutorial[isStarted] {
  animation-duration: 1s;
  animation-name: fade-in;
  animation-fill-mode: forwards;
}
.MerchantModal .Tutorial[isStarted] .Link {
  pointer-events: all;
}
.MerchantModal .Tutorial[isDone] {
  animation-duration: 2s;
  animation-name: fade-out;
  animation-fill-mode: forwards;
}
.MerchantModal .Tutorial .Fill {
  top: -5em;
  left: -8em;
  right: -8em;
  bottom: -5em;
  z-index: 1000;
  position: absolute;
  background: radial-gradient(circle 2em at center, transparent 1.9em, rgba(0, 0, 0, 0.8) 2em);
  transform: scale(10);
  animation-name: zoom-in;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 1s;
  animation-delay: 1s;
  pointer-events: none;
}
.MerchantModal .Tutorial .Fill[size="big"] {
  background: radial-gradient(circle 3em at center, transparent 2.9em, rgba(0, 0, 0, 0.8) 3em);
}
.MerchantModal .Tutorial .Fill[size="small"] {
  background: radial-gradient(circle 1em at center, transparent 0.9em, rgba(0, 0, 0, 0.8) 1em);
}
.MerchantModal .Tutorial .Message {
  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-fill-mode: forwards;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 1000000000;
}
.MerchantModal .Tutorial .Message[position="left"] {
  top: 0em;
  bottom: 0em;
  right: 10.25em;
}
.MerchantModal .Tutorial .Message[position="right"] {
  top: 0em;
  bottom: 0em;
  left: 10.25em;
}
.MerchantModal .Tutorial .Message[position="top"] {
  left: 0em;
  right: 0em;
  bottom: 6.25em;
}
.MerchantModal .Tutorial .Message[position="center"] {
  left: 0em;
  right: 0em;
  top: 0em;
  bottom: 0em;
}
.MerchantModal .Tutorial .Message[size=small] .Text {
  font-size: 0.25em;
}
.MerchantModal .Tutorial .Message .Box {
  border-radius: 0.1em;
  color: #111111;
  border-color: #051F29;
  background-color: #f0ead6;
}
.MerchantModal .Tutorial .Message .Box .Text {
  font-size: 0.33em;
  padding: 0.2em 0.6em;
  text-align: center;
}
.MerchantModal .Tutorial .Message .Box .Text .Link {
  opacity: 0.5;
}
.MerchantModal .Tutorial .Message .Box .Text .Link:hover {
  opacity: 1;
  color: #d54b33;
  cursor: pointer;
}
